<template>
  <div class="locale-changer">
    <Dropdown
      style="height: 3em"
      v-model="$i18n.locale"
      @change="updateLocale"
      optionLabel="label"
      optionValue="value"
      :options="languageOptions"
      expanded
    >
      <template #option="{ option }">
        <div>
          {{ getCountryName(option.value) }}
        </div>
      </template>
    </Dropdown>
  </div>
</template>

<script>
import api from "@/api";
import moment from "moment";

export default {
  name: "locale-changer",
  data() {
    return {
      languageOptions: [
        { label: this.getCountryName("ja"), value: "ja" },
        { label: this.getCountryName("en"), value: "en" },
      ],
    };
  },
  methods: {
    getCountryName(lang) {
      const countryNameMap = {
        ja: "日本語",
        en: "English",
      };
      return countryNameMap[lang];
    },
    updateLocale(newLocale) {
      if (newLocale && (newLocale === "ja" || newLocale === "en")) {
        api.switchUserLocale(newLocale).then(response => {
          console.log("🏀 Switching locale");
          this.$store.commit("setLocale", newLocale);
          moment.locale(newLocale);
          setTimeout(() => {
            this.refreshLeagueInformation();
          }, 1000);
        });
      }
    },
  },
  watch: {
    "$i18n.locale": function(newLocale) {
      this.updateLocale(newLocale);
    },
  },
};
</script>
